var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgClose(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m14.79 12.52 9.735-9.734a1.617 1.617 0 0 0 0-2.29 1.618 1.618 0 0 0-2.29 0L12.5 10.23 2.765.495a1.618 1.618 0 0 0-2.29 0 1.617 1.617 0 0 0 0 2.29l9.735 9.735-9.735 9.735A1.618 1.618 0 0 0 1.62 25.02c.415 0 .83-.159 1.145-.474L12.5 14.81l9.735 9.735a1.615 1.615 0 0 0 2.29 0 1.618 1.618 0 0 0 0-2.29L14.79 12.52z",
    fill: "#fff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClose);
export default __webpack_public_path__ + "static/media/close.bc9aca29f4083ccef45eaf6382bdde7a.svg";
export { ForwardRef as ReactComponent };